import { create } from 'zustand';

import { createSaveAsSkillSlice, type SaveAsSkillSlice } from './slices/createSaveAsSkillSlice';

export type SaveAsSkillState = SaveAsSkillSlice;

const EMPTY_DISMISSED: Record<string, boolean> = {};

export const useSaveAsSkillStore = create<SaveAsSkillState>()((...args) => ({
  ...createSaveAsSkillSlice()(...args),
}));

export const useDismissedSaveAsSkillSuggestionsForThread = (threadId: string | null): Record<string, boolean> => {
  return useSaveAsSkillStore((state) =>
    threadId ? (state.dismissedByThread[threadId] ?? EMPTY_DISMISSED) : EMPTY_DISMISSED,
  );
};
